import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../Components/url';
import './Registros.css';

export default function Registros() {
    const [form, setForm] = useState({
        nombre_negocio: '',
        tipo_negocio: 'comidas',
        rubro: '',
        nombre_dueno: '',
        cedula: '',
        email: '',
        telefono: '',
        direccion: '',
        instagram: '',
        facebook: '',
        plan: 'basic',
    });
    const [logo, setLogo] = useState(null);
    const [enviando, setEnviando] = useState(false);

    const COLORES = ['#0D9488', '#2563EB', '#7C3AED', '#DB2777', '#DC2626', '#EA580C', '#CA8A04', '#16A34A', '#0F172A', '#000000'];
    const [color, setColor] = useState('#0d9488');

    const handleChange = (e) => {
        const value = e.target.value;
        if (e.target.name === 'plan' && value === 'plus') {
            Swal.fire({
                title: 'Plan Plus',
                html: 'Para que el <b>Plan Plus</b> funcione, debes cancelar el valor de ese plan.',
                icon: 'info',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#0d9488',
            });
        }
        setForm({ ...form, [e.target.name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEnviando(true);

        try {
            const formData = new FormData();
            Object.keys(form).forEach((k) => formData.append(k, form[k]));
            formData.append('color', color.toUpperCase());
            if (logo) formData.append('logo', logo);

            const response = await fetch(`${baseURL}/solicitudPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.mensaje) {
                const mensajeWhatsapp = `Hola me registre en shop con el nombre ${data.slug} puedes agilizar mi proceso?`;
                const urlWhatsapp = `https://api.whatsapp.com/send/?phone=3014077600&text=${encodeURIComponent(mensajeWhatsapp)}`;
                await Swal.fire({
                    title: '¡Solicitud enviada! 🎉',
                    html: `
                        <p style="font-size:14px;color:#475569;margin-bottom:10px;">¡Gracias por confiar en nosotros! Ya estamos trabajando para que tu sistema funcione correctamente. 💪</p>
                        <p style="font-size:14px;color:#475569;margin-bottom:10px;">Te contactaremos cuando tu espacio esté listo.</p>
                        <p style="font-size:14px;color:#475569;margin:0;">Tu tienda estará disponible en:</p>
                        <p style="font-size:16px;font-weight:600;color:#0d9488;margin:6px 0 14px;">https://shop.solutiontechvp.com/${data.slug}</p>
                        <p style="font-size:13px;color:#475569;margin:0 0 10px;">¿Querés agilizar el proceso? Escríbenos por WhatsApp</p>
                        <a href="${urlWhatsapp}" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;justify-content:center;gap:8px;background:#25D366;color:#fff;text-decoration:none;font-size:15px;font-weight:600;padding:12px 22px;border-radius:50px;">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.019-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
                            Agilizar por WhatsApp
                        </a>
                    `,
                    icon: 'success',
                    confirmButtonText: '¡Genial!',
                    confirmButtonColor: '#0d9488',
                });
                setForm({
                    nombre_negocio: '', tipo_negocio: 'comidas', rubro: '', nombre_dueno: '',
                    cedula: '', email: '', telefono: '', direccion: '', instagram: '', facebook: '', plan: 'basic',
                });
                setLogo(null);
                setColor('#0d9488');
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (err) {
            console.error(err);
            toast.error('Error al enviar la solicitud');
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className='registros'>
            <ToastContainer />
            <div className='registrosHeader'>
                <h1>Crea tu tienda online</h1>
                <p>Completá tus datos y te preparamos tu espacio de trabajo.</p>
            </div>

            <form className='registrosForm' onSubmit={handleSubmit}>
                <div className='campo'>
                    <label>Nombre del negocio *</label>
                    <input name='nombre_negocio' value={form.nombre_negocio} onChange={handleChange} required placeholder='Mi Negocio' />
                </div>

                <div className='fila'>
                    <div className='campo'>
                        <label>Tipo de negocio</label>
                        <select name='tipo_negocio' value={form.tipo_negocio} onChange={handleChange}>
                            <option value='comidas'>Comidas / Restaurante</option>
                            <option value='tienda'>Tienda / Productos</option>
                        </select>
                    </div>
                    <div className='campo'>
                        <label>Rubro</label>
                        <input name='rubro' value={form.rubro} onChange={handleChange} placeholder='Ej: Pizzería, Ropa, Tecnología' />
                    </div>
                </div>

                <div className='fila'>
                    <div className='campo'>
                        <label>Nombre del dueño *</label>
                        <input name='nombre_dueno' value={form.nombre_dueno} onChange={handleChange} required placeholder='Tu nombre' />
                    </div>
                    <div className='campo'>
                        <label>Cédula</label>
                        <input name='cedula' value={form.cedula} onChange={handleChange} placeholder='Cédula / RUC' />
                    </div>
                </div>

                <div className='fila'>
                    <div className='campo'>
                        <label>Email *</label>
                        <input name='email' type='email' value={form.email} onChange={handleChange} required placeholder='tucorreo@mail.com' />
                        <p className='emailAyuda'>Asegurate de que el correo sea válido: ahí te enviaremos tus credenciales de acceso al sistema.</p>
                    </div>
                    <div className='campo'>
                        <label>Teléfono *</label>
                        <input name='telefono' value={form.telefono} onChange={handleChange} required placeholder='+00 000 000 0000' />
                    </div>
                </div>

                <div className='campo'>
                    <label>Dirección</label>
                    <input name='direccion' value={form.direccion} onChange={handleChange} placeholder='Dirección del local' />
                </div>

                <div className='fila'>
                    <div className='campo'>
                        <label>Instagram</label>
                        <input name='instagram' value={form.instagram} onChange={handleChange} placeholder='https://instagram.com/tu_cuenta' />
                    </div>
                    <div className='campo'>
                        <label>Facebook</label>
                        <input name='facebook' value={form.facebook} onChange={handleChange} placeholder='https://facebook.com/tu_pagina' />
                    </div>
                </div>

                <div className='fila'>
                    <div className='campo'>
                        <label>Plan</label>
                        <select name='plan' value={form.plan} onChange={handleChange}>
                            <option value='basic'>Básico</option>
                            <option value='plus'>Plus</option>
                        </select>
                    </div>
                    <div className='campo'>
                        <label>Logo</label>
                        <input type='file' accept='image/*' onChange={(e) => setLogo(e.target.files[0])} />
                    </div>
                </div>

                <div className='campo'>
                    <label>Color de tu tienda</label>
                    <div className='colorPicker'>
                        {COLORES.map((c) => (
                            <button
                                type='button'
                                key={c}
                                className={`swatch ${color.toUpperCase() === c ? 'swatchActivo' : ''}`}
                                style={{ background: c }}
                                onClick={() => setColor(c)}
                                aria-label={`Elegir color ${c}`}
                            />
                        ))}
                        <input
                            type='color'
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                            aria-label='Color personalizado'
                        />
                        <span className='colorHex'>{color.toUpperCase()}</span>
                    </div>
                    <p className='colorAyuda'>Este color se verá en tu navbar, botones y toda tu tienda.</p>
                    <div className='colorPreview'>
                        <span style={{ background: color }} className='previewDot' />
                        <span style={{ background: color, color: '#fff' }} className='previewBtn'>Botón</span>
                        <span style={{ borderBottom: `2px solid ${color}` }} className='previewNav'>Navbar</span>
                    </div>
                </div>

                <button type='submit' className='btnEnviar' disabled={enviando}>
                    {enviando ? 'Enviando...' : 'Enviar solicitud'}
                </button>
            </form>
        </div>
    );
}
